import { defineComponent as P, useSlots as U, useCssModule as q, useAttrs as G, ref as y, computed as c, watchEffect as L, onMounted as W, createBlock as V, openBlock as f, mergeProps as B, unref as l, createSlots as j, withCtx as k, createElementVNode as N, withDirectives as H, createElementBlock as x, createCommentVNode as I, vModelDynamic as J, normalizeClass as v, renderSlot as b } from "vue";
import C from "lodash-es/isNil";
import { convertDecimal as D, sanitizeDecimal as K, decimalSeparator as h } from "./utils/i18n.js";
import { _ as Q } from "./Field.vue_vue_type_script_setup_true_lang-DRaKs9Lm.js";
import X from "./Icon.js";
import { _ as Y } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const Z = { class: "tw-relative" }, ee = ["id", "aria-errormessage", "aria-invalid", "autocomplete", "placeholder", "type", "disabled", "readonly"], te = /* @__PURE__ */ P({
  name: "ll-input",
  inheritAttrs: !1,
  __name: "Input",
  props: {
    autocomplete: { default: "off" },
    modelValue: { default: "" },
    value: { default: null },
    type: { default: "text" },
    placeholder: { default: void 0 },
    addBottomSpace: { type: Boolean },
    errorText: {},
    hintText: {},
    id: {},
    errorId: {},
    isReadOnly: { type: Boolean },
    isRequired: { type: Boolean },
    label: {},
    showOptionalInLabel: { type: Boolean },
    fieldset: { type: Boolean },
    isDisabled: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:model-value", "change", "focus", "blur"],
  setup($, { expose: E, emit: S }) {
    const e = $, m = S, r = U(), s = q(), u = G(), _ = y();
    E({ inputEl: _ });
    const n = y(e.modelValue);
    e.type === "number" && (e.modelValue || e.modelValue === 0) && (n.value = D(e.modelValue, h));
    const i = y(!1), M = c(() => e.isReadOnly || "readonly" in u && u.readonly !== !1), d = c(() => e.type === "number"), A = c(() => {
      const o = { ...u };
      return delete o.class, o;
    }), F = c(() => d.value || e.type === "password" && i.value ? "text" : e.type);
    L(() => {
      n.value = w(e.modelValue);
    });
    function g(o = "", a = !1) {
      if (!d.value)
        return o;
      let t = o;
      if (C(t) || `${t}`.length === 0) return "";
      if (h !== "." && (t = D(t, ".")), a && (t === "." && (t = "0."), t.toString().startsWith("0.")))
        return t;
      if (!C(t) && `${t}`.length)
        t = Intl.NumberFormat("en-US", {
          style: "decimal",
          maximumFractionDigits: 7,
          useGrouping: !1
        }).format(Number(t));
      else
        return "";
      return isNaN(Number(t)) ? "" : parseFloat(t);
    }
    function w(o) {
      return d.value ? K(o, h) : o;
    }
    function O() {
      const o = d.value ? g(n.value) : n.value;
      m("change", o);
    }
    function R(o) {
      const a = o.target.value;
      n.value = w(a);
      const t = d.value ? g(n.value, !0) : a;
      m("update:model-value", t);
    }
    return W(() => {
      if (e.value !== null)
        throw new Error("ll-input: use :model-value or v-model instead of :value.");
      if (u.onInput)
        throw new Error("ll-input: use the @update:model-value event instead of @input");
    }), (o, a) => (f(), V(Q, B(e, {
      class: ["stash-input", [l(s).root, l(u).class]],
      "data-test": "ll-input"
    }), j({
      default: k(({ fieldId: t, fieldErrorId: T, hasError: z }) => [
        N("div", Z, [
          H(N("input", B(A.value, {
            id: t,
            ref_key: "inputEl",
            ref: _,
            "onUpdate:modelValue": a[0] || (a[0] = (p) => n.value = p),
            "aria-errormessage": T,
            "aria-invalid": z,
            autocomplete: o.autocomplete,
            placeholder: e.placeholder,
            class: [
              { [l(s)["input-prepended"]]: !!l(r).prepend },
              { [l(s)["input-appended"]]: !!l(r).append || e.type === "password" },
              { [l(s)["has-error"]]: !!e.errorText }
            ],
            type: F.value,
            disabled: e.isDisabled || e.disabled,
            readonly: M.value,
            onChange: O,
            onInput: R,
            onBlur: a[1] || (a[1] = (p) => m("blur", p)),
            onFocus: a[2] || (a[2] = (p) => m("focus", p))
          }), null, 16, ee), [
            [J, n.value]
          ]),
          l(r).prepend ? (f(), x("div", {
            key: 0,
            class: v(["stash-input-prepend font-semibold", [l(s).symbol, l(s)["symbol--prepend"]]])
          }, [
            b(o.$slots, "prepend")
          ], 2)) : I("", !0),
          l(r).append || e.type === "password" ? (f(), x("div", {
            key: 1,
            class: v(["stash-input-append font-semibold", [l(s).symbol, l(s)["symbol--append"]]])
          }, [
            l(r).append ? b(o.$slots, "append", { key: 0 }) : (f(), V(X, {
              key: 1,
              name: i.value ? "hide" : "show",
              class: v(["tw-cursor-pointer", { "tw-text-ice-500": e.isDisabled || e.disabled }]),
              "data-test": i.value ? "hide-password-icon" : "show-password-icon",
              onClick: a[3] || (a[3] = (p) => i.value = !i.value)
            }, null, 8, ["name", "class", "data-test"]))
          ], 2)) : I("", !0)
        ])
      ]),
      _: 2
    }, [
      l(r).hint ? {
        name: "hint",
        fn: k(() => [
          b(o.$slots, "hint")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["class"]));
  }
}), oe = "_root_1tgop_2", le = "_symbol_1tgop_46", ae = {
  root: oe,
  "has-error": "_has-error_1tgop_34",
  "input-prepended": "_input-prepended_1tgop_38",
  "input-appended": "_input-appended_1tgop_42",
  symbol: le,
  "symbol--prepend": "_symbol--prepend_1tgop_57",
  "symbol--append": "_symbol--append_1tgop_63"
}, se = {
  $style: ae
}, me = /* @__PURE__ */ Y(te, [["__cssModules", se]]);
export {
  me as default
};
//# sourceMappingURL=Input.js.map
